module.exports = __webpack_public_path__ + "static/media/detail_0019_t.a93eb932.jpg";